import React from 'react'
import { useStyles } from './styles'
import { concatStyles } from 'src/utils'

interface ImgIconProps {
  src: string
  alt?: string
  className?: string
}

export const ImgIcon = ({ src, alt, className }: ImgIconProps) => {
  const styles = useStyles()
  return <img src={src} alt={alt} className={concatStyles(styles.root, className)} />
}
